/* eslint-disable no-bitwise */

/** Make a HEX color lighter without setting opacity */
export function lightenColor(hex: string, percent: number): string {
  // Pass through CSS keyword "inherit"
  if (hex.trim().toLowerCase() === 'inherit') {
    return hex;
  }

  // Remove the '#' symbol (if present) to work with a clean hex value
  const preparedHex = hex.replace(/^#/, '');

  // Check that the provided format is correct (6 characters expected)
  if (preparedHex.length !== 6) {
    throw new Error(
      'Invalid hex color format. Expected a string in the format "#RRGGBB" or "RRGGBB".',
    );
  }

  // Convert the string into a number
  const num = parseInt(preparedHex, 16);

  // Extract R, G, and B components
  let r = (num >> 16) & 0xff;
  let g = (num >> 8) & 0xff;
  let b = num & 0xff;

  // Calculate new values for each component.
  // This formula adds a portion of the difference towards 255 (white) to the current value.
  r = Math.round(r + (255 - r) * (percent / 100));
  g = Math.round(g + (255 - g) * (percent / 100));
  b = Math.round(b + (255 - b) * (percent / 100));

  // Ensure the values remain within the range of 0-255
  r = Math.min(255, Math.max(0, r));
  g = Math.min(255, Math.max(0, g));
  b = Math.min(255, Math.max(0, b));

  // Convert each component back to a two-character hexadecimal string
  const rHex = r.toString(16).padStart(2, '0');
  const gHex = g.toString(16).padStart(2, '0');
  const bHex = b.toString(16).padStart(2, '0');

  // Assemble the final hex color
  return `#${rHex}${gHex}${bHex}`;
}
